let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lYlZW")).then(() => parcelRequire('51pqL'));